import React, { useCallback } from 'react';
import { Pressable, Linking, Image, StyleSheet, View } from 'react-native';

// import Donation from '../assets/donation.svg'
type OpenURLButtonProps = {
  url: string;
  children: any;
  style: any;
};

type Props = {
  testID?: string;
  image: any;
  url?: string;
  color?: string;
  onPress?: () => void;
  size?: number;
};

const OpenURLButton = ({ url, children, style }: OpenURLButtonProps) => {
  const handlePress = useCallback(async () => {
    // Checking if the link is supported for links with custom URL scheme.
    const supported = await Linking.canOpenURL(url);

    if (supported) {
      // Opening the link with some app, if the URL scheme is "http" the web link should be opened
      // by some browser in the mobile
      await Linking.openURL(url);
    } else {
      console.log('cannot open url');
    }
  }, [url]);

  return (
    <Pressable onPress={handlePress} style={style.button}>
      {children}
    </Pressable>
  );
};

export function RoundButton(props: Props) {
  const { image, url, color, testID = 'RoundButton', onPress, size } = props;
  const style = createStyle(color, size);

  if (url) {
    return (
      <OpenURLButton url={url} style={style}>
        <Image source={image} style={style.image} />
      </OpenURLButton>
    );
  }

  if (onPress) {
    return (
      <Pressable onPress={onPress} style={style.button} testID={testID}>
        <Image source={image} style={style.image} />
      </Pressable>
    );
  }

  return (
    <View style={style.button} testID={testID}>
      <Image source={image} style={style.image} />
    </View>
  );
}

function createStyle(color = '#e1e126', size = 60) {
  return StyleSheet.create({
    button: {
      width: size,
      height: size,
      backgroundColor: color,
      borderRadius: size / 2,
      padding: size / 6,
      shadowRadius: 5,
      shadowOpacity: 0.1,
    },
    image: {
      width: '100%',
      height: '100%',
    },
  });
}
